// import Vue from "vue";
// import VueAxios from "vue-axios";
import store from "../store";

import axios from "axios";

const axiosClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

axiosClient.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${store.getters["authToken"]}`;
  return config;
});

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch("login");
    }
    throw error;
  }
);

export default axiosClient;
